import { defineMessages } from 'react-intl'

export default defineMessages({
  metaTitle: {
    id: 'containers.Browse.meta.title',
    defaultMessage:
      '{language} Voice Over • Find {language} Voice Actors and Talents | VoiceArchive',
  },
  metaDescription: {
    id: 'containers.Browse.meta.description',
    defaultMessage:
      'Listen to {language} voice actors and talents. Find the perfect voice for your project. Free custom demo. Quick and easy.',
  },
  metaTitleDefault: {
    id: 'containers.Browse.meta.titleDefault',
    defaultMessage:
      'Find Voice Actors & Voice Talents | VoiceArchive',
  },
  metaDescriptionDefault: {
    id: 'containers.Browse.meta.descriptionDefault',
    defaultMessage:
      'Browse professional voice actors and voice talents. Find the perfect voice for your project. Free custom demo. Quick and easy.',
  },
})
